import * as types from "../../constants/actionTypes";

export const fetchMyTopologies = (user, environments) => ({
  type: types.FETCH_MYTOPOS_REQUESTED,
  user,
  environments,
});

export const deleteTopology = (id, environment) => ({
  type: types.DELETE_REQUESTED,
  id,
  environment,
});

export const fetchTasks = (machineName, topologyId, environment) => ({
  type: types.FETCH_TASKS_REQUESTED,
  machineName,
  topologyId,
  environment,
});

export const closeTasks = () => ({
  type: types.CLOSE_TASKS,
});

export const renameTopology = (owner, workgroupId, newName, environment) => ({
  type: types.RENAME_TOPOLOGY_REQUESTED,
  owner: owner,
  id: workgroupId,
  newName: newName,
  environment: environment,
});

export const transferOwnership = (owner, id, newOwner, environment) => ({
  type: types.TRANSFER_OWNERSHIP_REQUESTED,
  owner: owner,
  id: id,
  newOwner: newOwner,
  environment: environment,
});

export const getDebuggerPort = (environment) => ({
  type: types.FETCH_DEBUGGER_PORT_REQUESTED,
  environment: environment,
});
